import React from 'react';
import OpeningHours from './OpeningHours';
import SocialMedia from './SocialMedia';
import ContactInfo from './ContactInfo';
import FooterCredit from './FooterCredit';

export default function FooterSection() {
  return (
    <footer className="bg-gradient-to-br from-red-700 to-red-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <OpeningHours />
          <ContactInfo />
          <SocialMedia />
        </div>
        <FooterCredit />
      </div>
    </footer>
  );
}